import { PaymentVendorProvider } from '../../../common';
import { useInsuranceCompanies } from '../../app-init-data';
import useGetIcByJourney from './useGetIcByJourney';

const useGetPaymentVendorByIc = ({ planId }: { planId: number }) => {
	const { getInsuranceCompanyByPlanId } = useGetIcByJourney({ planId });

	const { getInsuranceCompanyById } = useInsuranceCompanies();

	const isTelrVendor = () => {
		const insuranceCompanyId = getInsuranceCompanyByPlanId()?.id;

		const icDetail = getInsuranceCompanyById(insuranceCompanyId!);

		return icDetail?.paymentVendorId === PaymentVendorProvider.TelrUAE;
	};

	return {
		isTelrVendor,
	};
};

export default useGetPaymentVendorByIc;
